module.exports = __webpack_public_path__ + "static/model-expressions-an-overlooked-aspect-of-domain-driven-design-56ffecf9f75f4c169a91b0822b66a2ee.png";